export class GameThermometor extends SpinePlugin.SpineGameObject {
  constructor(scene, x, y) {
    super(scene, scene.spine, x, y, 'thermometer', '', true);
    scene.add.existing(this);

    this._state = 'idle';
    this.visible = false;
    this.timeAnimation = this.findAnimation('animation');
  }

  enter() {
    this.visible = true;
    this.timeScale = 1;
    this.play('in');
  }

  exit() {
    this.visible = true;
    this.timeScale = 1;
    this.play('out');
  }

  setTimePercent(percent) {
    this.visible = true;
    const time = this.timeAnimation.duration * percent;
    this.state.setAnimation(0, 'animation', false).trackTime = time;
    this.timeScale = 0;
  }
}
